import { Box, Modal, TextField, Typography } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { Form, Formik } from "formik";
import { postAPICall } from "lib/callApi";
import { CHECK_IF_FUNNEL_NAME_IS_UNIQUE } from "lib/constants";

import * as Yup from "yup";

function RenameFunnelModal({ style, open, handleClose, title, handleRename }) {
  const isFunnelTitleUnique = async (newTitle) => {
    try {
      let isUnique = false;
      const response = await postAPICall(CHECK_IF_FUNNEL_NAME_IS_UNIQUE, true, {
        title: newTitle,
      });
      if (response?.data?.success) {
        isUnique = response.data.data.isUnique;
      }
      return isUnique;
    } catch (error) {
      return false;
    }
  };

  const validationSchema = Yup.object({
    title: Yup.string()
      .max(30, "Title cannot be more than 30 characters")
      .required("Title is required")
      .test("unique-title", "Funnel with that title already exists", async (value) => {
        const isUnique = await isFunnelTitleUnique(value);
        if (!isUnique) {
          throw new Yup.ValidationError("Funnel with that title already exists", value, "title");
        }
        return true;
      }),
  });

  const handleSubmit = (data) => {
    handleRename(data.title);
    handleClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography variant="h4" sx={{ mb: "1rem" }}>
          Rename Funnel
        </Typography>
        <Formik
          initialValues={{ title }}
          enableReinitialize
          validateOnBlur
          validateOnChange={false}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, touched, errors }) => (
            <Form>
              <TextField
                label="Title"
                defaultValue={values.title || "New Funnel"}
                onChange={(event) => setFieldValue("title", event.target.value)}
                error={Boolean(touched.title && errors.title)}
                helperText={touched.title && errors.title}
                sx={{ width: "100%" }}
                inputProps={{ maxLength: 30 }}
              />
              <MDBox mt={2} sx={{ display: "flex", justifyContent: "flex-end" }}>
                <MDButton onClick={handleClose} color="gray80" style={{ marginRight: "10px" }}>
                  Cancel
                </MDButton>
                <MDButton type="submit" color="primaryRed">
                  Save
                </MDButton>
              </MDBox>
            </Form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}

export default RenameFunnelModal;
